import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  overWrap: {
    whiteSpace: 'pre-line',
    width: '500px'
  },
  verticalAlignTop: {
    verticalAlign: 'top'
  },
  buttonDelete: {
    paddingTop: '0px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      monthConfirm: PropTypes.number,
      totalTransferAmount: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const InvoiceGochiHistoryTableBody = enhance(
  ({ classes, invoices, emptyRows, order, orderBy }) => {
    // searchEs
    let sortedResult = [];
    if (orderBy === 'monthConfirm') {
      sortedResult = _.orderBy(
        invoices,
        invoice => {
          return invoice.monthConfirm;
        },
        order
      );
    } else if (orderBy === 'totalTransferAmount') {
      sortedResult = _.orderBy(
        invoices,
        invoice => {
          return invoice.totalTransferAmount;
        },
        order
      );
    } else if (orderBy === 'createdAt') {
      sortedResult = _.orderBy(
        invoices,
        invoice => {
          return invoice.createdAt;
        },
        order
      );
    } else {
      sortedResult = _.orderBy(invoices, orderBy, order);
    }

    return (
      <TableBody>
        {sortedResult
          // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((invoice, index) => {
            const key = index;
            return (
              <TableRow key={key} className={classes.verticalAlignTop}>
                <TableCell>{invoice.monthConfirm}</TableCell>
                <TableCell>{invoice.totalTransferAmount}</TableCell>
                <TableCell>{invoice.createdAt}</TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow>
            <TableCell colSpan={3} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(InvoiceGochiHistoryTableBody);
